import { ApiConfig, RolePermissionInterface } from "./Interfaces";

export class ApiHelper {

  static apiConfigs: ApiConfig[] = [];
  static isAuthenticated = false;

  static getConfig() {
    let result: ApiConfig = this.apiConfigs[0];
    //this.apiConfigs.forEach(config => { if (config.keyName === keyName) result = config });
    //if (result === null) throw new Error("Unconfigured API: " + keyName);
    return result;
  }

  static setDefaultPermissions(jwt: string) {
    this.apiConfigs.forEach(config => {
      config.jwt = jwt;
      config.permissions = [];
    });
    this.isAuthenticated = true;
  }

  static setPermissions(keyName: string, jwt: string, permissions: RolePermissionInterface[]) {
    this.apiConfigs.forEach(config => {
      if (config.keyName === keyName) {
        config.jwt = jwt;
        config.permissions = permissions;
      }
    });
    this.isAuthenticated = true;
  }

  static clearPermissions() {
    this.apiConfigs.forEach(config => { config.jwt = ""; config.permissions = []; });
    this.isAuthenticated = false;
  }

  static async get<T = unknown>(path: string): Promise<T | null> {
    const config = this.getConfig();
    try {
      const requestOptions = { method: "GET", headers: { Authorization: "Bearer " + config.jwt } };
      const response = await fetch(config.url + path, requestOptions);
      const data = await response.text();
      try { return JSON.parse(data) }
      catch { return null; }
    } catch (e) {
      throw (e);
    }
  }

  static async getAnonymous<T = unknown>(path: string): Promise<T | null> {
    const config = this.getConfig();
    try {
      const requestOptions = { method: "GET" };
      const response = await fetch(config.url + path, requestOptions);
      const data = await response.text();
      try { return JSON.parse(data) }
      catch { return null; }
    } catch (e) {
      throw (e);
    }
  }

  static async post<T = unknown>(path: string, data: unknown): Promise<T> {
    const config = this.getConfig();
    const requestOptions = {
      method: "POST",
      headers: { Authorization: "Bearer " + config.jwt, "Content-Type": "application/json" },
      body: JSON.stringify(data)
    };
    return fetch(config.url + path, requestOptions).then(response => response.json())
  }

  static async delete(path: string) {
    const config = this.getConfig();
    const requestOptions = {
      method: "DELETE",
      headers: { Authorization: "Bearer " + config.jwt }
    };
    return fetch(config.url + path, requestOptions);
  }

  static async postAnonymous<T = unknown>(path: string, data: unknown): Promise<T> {
    const config = this.getConfig();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    };
    const response = await fetch(config.url + path, requestOptions);
    try {
      const json = await response.json();
      if (!response.ok && !json.errors) {
        json.errors = ["An unexpected error occurred. Please try again."];
      }
      return json;
    } catch {
      return { errors: ["An unexpected error occurred. Please try again."] } as T;
    }
  }

}